import { useMutation, useQueryClient } from "@tanstack/react-query";
import ApiService from "../../services/ApiService";
import { POST_COMMENTS, } from "../keys";
import { useSelector } from "react-redux";

const usePostComment = () => {
  const tenant = useSelector((state) => state.auth.tenant);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => ApiService.postComment(payload),
		onMutate: async (payload) => {
			// Cancel any outgoing refetches to avoid overwriting optimistic update
			await queryClient.cancelQueries([POST_COMMENTS, tenant?.id, 'instagram', payload.post_id]);
			
			// Get the current query data
			const previousComments = queryClient.getQueryData([POST_COMMENTS, tenant?.id, 'instagram', payload.post_id]);
			
			// Return early if no previous data or invalid structure
			if (!previousComments || !previousComments.data || !previousComments.data.data) {
				console.log('No previous comments data available for optimistic update');
				return { previousComments };
			}
			
			// Create a copy to avoid direct mutation
			const updatedComments = JSON.parse(JSON.stringify(previousComments));
			
			// Update the comments with optimistic data
			updatedComments.data.data = updatedComments.data.data.map((comment) => {
				if (comment.id === payload.parent_comment_id) {
					// Create replies array if it doesn't exist
					if (!comment.replies || !comment.replies.data) {
						comment.replies = { data: [] };
					}
					
					comment.replies.data.push({
						id: `temp-${Math.random()}`,
						text: payload.comment, // Fixed: using text instead of comment to match API structure
						timestamp: new Date().toISOString(),
						username: 'You',
						like_count: 0
					});
				}
				return comment;
			});

			// Set the updated comments
			queryClient.setQueryData(
				[POST_COMMENTS, tenant?.id, 'instagram', payload.post_id], 
				updatedComments
			);
			
			return { previousComments };
		},
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([POST_COMMENTS, tenant?.id, 'instagram', variables.post_id]);
    },
		onError: (error, variables, context) => {
			console.error('Error posting comment:', error);
			// If we have previous data, rollback to it
			if (context?.previousComments) {
				queryClient.setQueryData(
					[POST_COMMENTS, tenant?.id, 'instagram', variables.post_id], 
					context.previousComments
				);
			}
			queryClient.invalidateQueries([POST_COMMENTS, tenant?.id, 'instagram', variables.post_id]);
		},
  });
};

export default usePostComment;
